"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import styles from "../css/DebtorsLanding.module.css";
import { LuUserRound, LuTruck, LuReceiptText } from "react-icons/lu";

export default function DebtorsLanding() {
  const navigate = useNavigate();
  return (
    <div className={styles.wrapper}>
      <Navbar backTo="/frontshop" />

      <main className={styles.main}>
        <div className={styles.cardsRow}>
          <button
            type="button"
            className={styles.card}
            onClick={() => navigate("/frontshop/debtors/credit-accounts")}
          >
            <span className={styles.cardIcon} aria-hidden="true">
              <LuUserRound />
            </span>
            <span className={styles.cardLabel}>Credit Accounts</span>
          </button>

          <button
            type="button"
            className={styles.card}
            onClick={() => navigate("/frontshop/debtors/cod-accounts")}
          >
            <span className={styles.cardIcon} aria-hidden="true">
              <LuTruck />
            </span>
            <span className={styles.cardLabel}>COD Accounts</span>
          </button>

          <button
            type="button"
            className={styles.card}
            onClick={() => navigate("/frontshop/debtors/transactions")}
          >
            <span className={styles.cardIcon} aria-hidden="true">
              <LuReceiptText />
            </span>
            <span className={styles.cardLabel}>Transactions</span>
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}
